module.exports = __webpack_public_path__ + "static/img_1.e9690165.png";